import type { CardHooks } from "./registry";
import { safeNum } from "@/lib/utils";

/**
 * Thrusting Release — special move: exhaust your weapon, add (weapon's power - 2)
 * to this attack. Surfaces as a prompt for the player to choose which ready
 * weapon slot to exhaust.
 */
export const thrustingRelease: CardHooks = {
  onAttackPlay: (ctx) => {
    const { self } = ctx;
    const ready = self.equipSlots
      .map((slot, slotIdx) => ({ slot, slotIdx }))
      .filter(({ slot }) => slot.cardId && !slot.tapped);
    if (!ready.length) return {};
    // The played-attack instance was just appended to attackDefendZone — use its
    // copy id (NOT the DB id) so the prompt resolver can mutate the right entry.
    const latest = self.attackDefendZone[self.attackDefendZone.length - 1];
    const adCopyId = latest?.id ?? "";
    return {
      prompt: {
        kind: "thrusting-release",
        playerNum: self.num,
        adCopyId,
        readySlots: ready.map(({ slot, slotIdx }) => ({
          slotIdx,
          cardId: slot.cardId as string,
          name: "Weapon",
          power: 0, // engine resolves real power from card db at confirm time
        })),
      },
      log: ["Thrusting Release — choose a weapon to exhaust for power"],
    };
  },
};

export function applyThrustingReleaseChoice(
  card: any,
  weaponPower: number,
): number {
  // Helper used by the prompt resolver in the engine
  const base = safeNum(card?.attackDefendFields?.powerValue ?? card?.equipmentFields?.powerValue ?? 0);
  return base + Math.max(0, weaponPower - 2);
}
